const NoImage = () => {
  return (
    <>
      <div className="w-100 d-flex justify-content-center pt-5">
        <div className="row justify-content-center">
          <div className="col-md-4 col-6">
            <img
              src="/img/no_image.png"
              className="w-100"
              alt="upload-layout"
            />
          </div>
        </div>
      </div>
      <h1 className="text-center text-muted">Silahkan pilih gambar</h1>
    </>
  );
};
export default NoImage;
